import React, { useEffect, useRef, useState, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { Form, OverlayTrigger, Tooltip, TooltipProps } from "react-bootstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate, useParams } from "react-router-dom";
import HistoryItem from "./HistoryItem";
import Filter from "./Filter";
import "./getConversation.css";
import ToggleTheme from "./ToggleTheme";
import {
  getChatsOpen,
  regenerateResponse,
  setChat1Data,
  setChat2Data,
  setChat3Data,
  setChat4Data,
  setChat5Data,
  setChat6Data,
  setIsGenerateImage,
  setIsGlobalSearch,
  setMinimizeSidebar,
  setNewConversation,
  setShowNavMenu,
  setUpLoadedFile,
  toggleFullWidthMode,
} from "../../../../store/one-query/chatsSlice";
import DeleteModal from "./DeletePopup";
import { getConversationTypes, useGetConversationHistory } from "../../../../store/Apis/ConversationApi";
import useProfilePictureGet from "../../../../store/Apis/UserApi";
import useDebounce from "./useDebounce";
import useNavigateToMainPage from "../../../../NavigateToMainPage";
import {
  ConversationData,
  conversationsActions,
} from "../../../../store/one-query/conversationSlice";
import UpgradePlanButton from "./UpgradePlanButton";
import MenuIcon from "../../../../Custom-imeges/MenuIcon";
import CloseMenuIcon from "../../../../Custom-imeges/CloseMenuIcon";
import SignalRService from "../../../one-query/services/SignalRService";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Badge,
  Box,
  ClickAwayListener,
  IconButton,
  Typography,
} from "@mui/material";
import { AppsIcon } from "../../../../Custom-imeges/SuitesIcons/AppsIcon";
import { AppViewType } from "../../../../Helper";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AddIcon from "@mui/icons-material/Add";
import { Tooltip as MuiTooltip } from "@mui/material";
import { tooltipStyles } from "../../../TextSuite/Components/TextSuitesBody";
import WorkflowsIcon from "../../../../Custom-imeges/WorkflowsIcon";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import LibraryIcon from "../../../../Custom-imeges/LibraryIcon";
interface GroupedData {
  [key: string]: ConversationData[];
}

const SidebarApp = () => {
  const { id } = useParams<{ id: string }>();
  const [showDeleteConversations, setShowDeleteConversations] = useState(false);
  const conversationsNames = useAppSelector((state) => state.Conversations);
  const filteredConversations= useAppSelector((s)=>s.Conversations.filteredConversations)
  const [search, setSearch] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const [converstionHistoryParams,setConverstionHistoryParams]=useState<getConversationTypes>({})
  const {data:getConversationHistoryData,error:getConversationHistoryError}=useGetConversationHistory(converstionHistoryParams)
  const getProfilePicture = useProfilePictureGet();
  const isUserUpdatePicture = useAppSelector(
    (s) => s.User?.isUserUpdatePicture
  );
  const userData = useAppSelector((s) => s.User);
  const debouncedSearchTerm = useDebounce(search, 1000);
  const showNavMenu = useAppSelector((s) => s.ChatsState.showNavMenu);
  const minimizeSidebar = useAppSelector((s) => s.ChatsState.minimizeSidebar);
  const ChatsStore = useAppSelector((s) => s.ChatsState);
  const [groupedData, setGroupedData] = useState<GroupedData>({});
  const navigateToMainPage = useNavigateToMainPage();
  const sidebarRef = useRef<HTMLDivElement>(null);
  const [showExploreApps, setShowExploreApps] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [filterPersona, setFilterPersona] = useState<string[]>([]);
  const navigate = useNavigate();
  const getDateGroup = (createdAt: string): string => {
    const date = new Date(createdAt);
    const now = new Date();

    const isToday = date.toDateString() === now.toDateString();
    if (isToday) return "Today";

    const isYesterday =
      new Date(now.setDate(now.getDate() - 1)).toDateString() ===
      date.toDateString();
    if (isYesterday) return "Yesterday";

    const isLastMonth =
      date.getFullYear() === now.getFullYear() &&
      date.getMonth() === now.getMonth() - 1;
    if (isLastMonth) return "Last Month";

    return "Older";
  };
 useEffect(()=>{
  if(getConversationHistoryData)
   dispatch(conversationsActions.getconverationsFilteredSuccess(getConversationHistoryData))
  if(getConversationHistoryError)
    dispatch(conversationsActions.getConversationError(getConversationHistoryError.message))
  },[getConversationHistoryData,getConversationHistoryError])
  const SuitesApps = [
    {
      appTitle: "Text suite",
      appIcon: <ArticleOutlinedIcon className="main-suites-app-icon" />,
    },
    {
      appTitle: "Image suite",
      appIcon: <ImageOutlinedIcon className="main-suites-app-icon" />,
    },
    {
      appTitle: "Video suite",
      appIcon: <VideocamOutlinedIcon className="main-suites-app-icon" />,
    },
  ];

  const toggleShowExploreApps = () => {
    if (!minimizeSidebar) {
      setShowExploreApps(!showExploreApps);
    }
  };

  const handleSelectSuiteApp = (appName: string) => {
    if (appName === "Text suite") {
      navigate("/suites");
    } else if (appName === "Image suite") {
      navigate("/suites/image-suite");
    } else if (appName === "Video suite") {
      navigate("/suites/video-suite");
    }
    handleCloseNavMenu();
    setShowExploreApps(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) dispatch(setMinimizeSidebar(false));
  }, [isMobile]);
  
  useEffect(() => {
    if(!filteredConversations) return;
    const grouped: GroupedData = filteredConversations?.reduce(
      (result: any, conversation: any) => {
        const groupName = getDateGroup(conversation.createdAt);
        if (!result[groupName]) {
          result[groupName] = [];
        }
        result[groupName].push(conversation);
        return result;
      },
      {}
    );

  setGroupedData(grouped);
}, [filteredConversations]);

  useEffect(() => {
    setConverstionHistoryParams({ Search: search,PersonaIds:filterPersona.length>0?filterPersona:null });
  }, [debouncedSearchTerm,filterPersona]);

  useEffect(() => {
    if (userData.userData?.id) {
      getProfilePicture(userData.userData?.id);
    }
  }, [userData.userData?.id]);

  useEffect(() => {
    if (!id && window.location.pathname === "/") {
      handleNewConversation();
    } else dispatch(setNewConversation(false));
  }, [window.location.pathname, id]);

  const handleNewConversation = () => {
    dispatch(setChat1Data({ id: "", version: "", name: "" }));
    dispatch(setChat2Data({ id: "", version: "", name: "" }));
    dispatch(setChat3Data({ id: "", version: "", name: "" }));
    dispatch(setChat4Data({ id: "", version: "", name: "" }));
    dispatch(setChat5Data({ id: "", version: "", name: "" }));
    dispatch(setChat6Data({ id: "", version: "", name: "" }));
    dispatch(setUpLoadedFile(false));
    dispatch(regenerateResponse(false));
    dispatch(toggleFullWidthMode(""));
  };

  const handleNewConversationClick = () => {
    handleNewConversation();
    navigateToMainPage();
    handleCloseNavMenu();
    if (!ChatsStore.newConversation) {
      dispatch(getChatsOpen({chatsNum:0,selectedOptions:[]}))
      dispatch(setIsGenerateImage(false));
      dispatch(setIsGlobalSearch(false));
    }
  };

  const handleShowNavMenu = () => {
    dispatch(setShowNavMenu(true));
  };

  const handleCloseNavMenu = () => {
    dispatch(setShowNavMenu(false));
  };

  const handleMinimizeSidebar = () => {
    dispatch(setMinimizeSidebar(!minimizeSidebar));
  };

  // Set new conversation name.
  const handleGetConversationName = useCallback(
    (SignalRConversationData: any) => {
      const updatedConversations = conversationsNames.conversations.map(
        (con) => {
          if (con.id === SignalRConversationData.conversationId) {
            return {
              ...con,
              name: SignalRConversationData.conversationName,
            };
          }
          return con;
        }
      );

      dispatch(
        conversationsActions.getConversationSuccess(updatedConversations)
      );
       dispatch(
        conversationsActions.getconverationsFilteredSuccess(updatedConversations)
      );
    },
    [conversationsNames.conversations]
  );

  const setupSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("SendConversationName", handleGetConversationName);
    return () => {
      connection.off("SendConversationName", handleGetConversationName);
    };
  }, [handleGetConversationName]);

  useEffect(() => {
    const cleanup = setupSignalRConnection();
    return () => {
      cleanup();
    };
  }, [setupSignalRConnection]);

  const handleClickOutside = (event: TouchEvent) => {
    if (
      sidebarRef.current &&
      !sidebarRef.current.contains(event.target as Node)
    ) {
      handleCloseNavMenu();
    }
  };

  useEffect(() => {
    if (showNavMenu) {
      document.addEventListener("touchstart", handleClickOutside);
    } else {
      document.removeEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [showNavMenu]);

  const handleNavigateToworkflows = () => {
    navigate("/workflows");
    handleCloseNavMenu();
  };
  const handleNavigateToLibrary=()=>{
    navigate("/library");
    handleCloseNavMenu();
  }
  const handleOpenSuitesApps = () => {
    navigate("/suites");
    handleCloseNavMenu();
  };

  return (
    <div
      className={`get-conversation-container ${
        minimizeSidebar && "minimize-sidebar"
      }
      ${showNavMenu ? "sidebar-container-open" : "sidebar-container-close"} ${
        showNavMenu && "open"
      }`}
      ref={sidebarRef}
    >
      <div className="sidebar-container">
        <div className="getConversations">
          {/* Logo */}
          <div className={`logo`}>
            <div
              className="menu-icon c-pointer"
              onClick={handleMinimizeSidebar}
            >
              <MenuIcon />
            </div>
            <div style={{
              display: "flex",
              alignItems: showNavMenu?"center":"start",
              marginTop:showNavMenu?"5px":undefined,
              marginBottom:"35px",
            }}>
            <div
              className="close-menu-container"
              onClick={!showNavMenu ? handleShowNavMenu : handleCloseNavMenu}
            >
              {!showNavMenu ? <MenuIcon /> : <CloseMenuIcon />}
            </div>
            <div className="app-logo-container">
              <img
                className="expertex-logo c-pointer d-block"
                onClick={navigateToMainPage}
              />
            </div>
            </div>
          </div>
          <>
            <div className="handle-conversations">
              <div className="new_clear_Conversation">
                <MuiTooltip
                  title="New conversation"
                  placement="right"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: "var(--A_background73)",
                        color: "var(--A_font-color48)",
                        padding: "0.3rem 0.8rem",
                        mt:minimizeSidebar?-2:undefined
                      },
                    },
                  }}
                  onClick={handleNewConversationClick}
                >
                  <div className={`side-nav-newConversation  new`}>
                    <div className="text">
                      <AddIcon
                        sx={{
                          color: "#FFF",
                          margin: "4px",
                          fontSize: "1.4rem",
                        }}
                      />
                      <p className="titleFont mb-0 new-text">
                        New conversation
                      </p>
                    </div>
                  </div>
                </MuiTooltip>
                {minimizeSidebar ? (
                  <>
                    <Box
                      className={`explore-apps-mini ${
                        window?.location?.pathname.includes("/suites") &&
                        "active"
                      }`}
                    >
                      <MuiTooltip
                        title="Explore Apps"
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "var(--A_background73)",
                              color: "var(--A_font-color48)",
                              padding: "0.3rem 0.8rem",
                            },
                          },
                        }}
                        onClick={handleOpenSuitesApps}
                      >
                        <IconButton>
                          <AppsIcon className="custom-icon" />
                        </IconButton>
                      </MuiTooltip>
                    </Box>
                    <Box
                      className={`explore-apps-mini ${
                        window.location.pathname.includes("/workflows") &&
                        "active"
                      }`}
                      onClick={handleNavigateToworkflows}
                    >
                      <MuiTooltip
                        title="Workflows"
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "var(--A_background73)",
                              color: "var(--A_font-color48)",
                              padding: "0.3rem 0.8rem",
                            },
                          },
                        }}
                      >
                        <IconButton>
                          <WorkflowsIcon className="custom-icon" />
                        </IconButton>
                      </MuiTooltip>
                    </Box>
                    <Box
                      className={`explore-apps-mini ${
                        window.location.pathname.includes("/library") &&
                        "active"
                      }`}
                      onClick={handleNavigateToLibrary}
                    >
                      <MuiTooltip
                        title="Library"
                        placement="right"
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "var(--A_background73)",
                              color: "var(--A_font-color48)",
                              padding: "0.3rem 0.8rem",
                            },
                          },
                        }}
                      >
                        <IconButton>
                          <Badge
                            badgeContent={"New"}
                            sx={{
                              '& .MuiBadge-badge': {
                                width: '29px',
                                height: '14px',
                                top: '-10px',
                                left: '-10px',
                                borderRadius: '2px',
                                backgroundColor: '#12B6EA',
                                color: '#191B22',
                                padding: '1px 4px',
                                fontSize: '10px',
                                fontWeight: '700',
                              },
                            }}
                          >
                            <LibraryIcon className="custom-icon" />
                          </Badge>
   
                        </IconButton>
                      </MuiTooltip>
                    </Box>
                  </>
                ) : (
                  <>
                    <ClickAwayListener
                      onClickAway={() => setShowExploreApps(false)}
                    >
                      <Box>
                        <Accordion
                          expanded={showExploreApps}
                          onChange={toggleShowExploreApps}
                          className={`apps-dropdown ${
                            showExploreApps ? "expanded" : ""
                          }`}
                          sx={{
                            backgroundColor: "transparent",
                            border: "none",
                            boxShadow: "none",
                            "&::before": { display: "none" },
                            padding: "0",
                          }}
                        >
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon className="main-suites-app-icon" />
                            }
                            sx={{
                              margin: "8px 0",
                              height: "36px",
                              minHeight: "36px",
                              paddingLeft: "0",
                              "&.Mui-expanded": {
                                height: "36px",
                                minHeight: "36px",
                              },
                            }}
                          >
                            <Box className="category-header">
                              <AppsIcon className="custom-icon" />
                              <Typography className="category-name">
                                Explore Apps
                              </Typography>
                            </Box>
                          </AccordionSummary>
                          {SuitesApps.map((app, index) => (
                            <AccordionDetails
                              key={index}
                              className="main-suites-app"
                              onClick={() => handleSelectSuiteApp(app.appTitle)}
                              sx={{ padding: "4px 16px" }}
                            >
                              <Box className="suites-app-type">
                                {app.appIcon}
                                <Typography
                                  className="suites-app-name"
                                  sx={{ fontSize: "12px" }}
                                >
                                  {app.appTitle}
                                </Typography>
                              </Box>
                            </AccordionDetails>
                          ))}
                        </Accordion>
                      </Box>
                    </ClickAwayListener>
                    <Accordion
                      expanded={false} // Keeps expanded for styling, but no details section
                      className={`apps-dropdown ${
                        window?.location?.pathname.includes("/workflows")
                          ? "active"
                          : ""
                      } ${false ? "expanded" : ""}`}
                      sx={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                        "&::before": { display: "none" },
                        padding: "0",
                      }}
                    >
                      <AccordionSummary
                        className="workflows-header"
                        sx={{
                          margin: "8px 0",
                          height: "36px",
                          minHeight: "36px",
                          paddingLeft: "0",
                        }}
                        onClick={handleNavigateToworkflows} // Handles navigation & style change
                      >
                        <Box className="category-header workflows-header">
                          <WorkflowsIcon className="custom-icon" />
                          <Typography className="category-name">
                            Workflows
                          </Typography>
                        </Box>
                      </AccordionSummary>
                    </Accordion>
                    <Accordion
                      expanded={false} // Keeps expanded for styling, but no details section
                      className={`apps-dropdown ${
                        window?.location?.pathname.includes("/library")
                          ? "active"
                          : ""
                      } ${false ? "expanded" : ""}`}
                      sx={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                        "&::before": { display: "none" },
                        padding: "0",
                      }}
                    >
                        <AccordionSummary
                        className="workflows-header"
                        sx={{
                          margin: "8px 0",
                          height: "36px",
                          minHeight: "36px",
                          paddingLeft: "0",
                          "& .MuiAccordionSummary-content": {
                          alignItems: "center",
                          gap: "8px",
                          },
                        }}
                        onClick={handleNavigateToLibrary} // Handles navigation & style change
                        >
                        <Box className="category-header workflows-header">
                          <LibraryIcon className="custom-icon" />
                          <Typography className="category-name">
                          Library
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                          width: "29px",
                          height: "14px",
                          borderRadius: "2px",
                          backgroundColor: "#12B6EA",
                          color: "#191B22",
                          padding: "1px 4px",
                          fontSize: "10px",
                          fontWeight: "700",
                          }}
                        >
                          New
                        </Box>
                        </AccordionSummary>
                    </Accordion>
                  </>
                )}
                <DeleteModal
                  show={showDeleteConversations}
                  handleClose={() => setShowDeleteConversations(false)}
                  name="Clear all conversations"
                  message="By confirming all your conversation data will be lost. This action can't be undone."
                />
              </div>
            </div>
            <div className="history">
              <div className="d-flex flex-column align-items-start">
                <div className="d-flex align-items-center justify-content-center mb-1 py-1 w-100">
                  <div className="searchBox" style={{ zIndex: "100000" }}>
                    <Form.Label
                      className="mb-0"
                      htmlFor="historySearch"
                      style={{ marginLeft: "5px" }}
                    >
                      <img
                        className="search-icon"
                        src={"/images/GetConversations/search-normal.svg"}
                      />
                    </Form.Label>
                    <Form.Control
                      id="historySearch"
                      placeholder="Search"
                      value={search || ""}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <Filter currentPlace="Sidebar" search={search??""} setFilterPersona={setFilterPersona}/>
                  </div>
                </div>
              </div>
              <div className="history-container overflow-x-hidden overflow-y-auto">
                {filteredConversations&&filteredConversations?.length > 0 ? (
                  Object.entries(groupedData).map(([group, items]) => (
                    <div key={group}>
                      <p className="group-name">{group}</p>
                      {items.map(({ name, createdAt, id, persona }) => (
                        <HistoryItem
                          key={id}
                          name={name || ""}
                          date={createdAt + ""}
                          id={id + ""}
                          category={persona?.title}
                        />
                      ))}
                    </div>
                  ))
                ) : (
                  <p className="empty-conversations">
                    Your conversations will appear here.
                  </p>
                )}
              </div>
            </div>

            <div className="profileContainer">
              <UpgradePlanButton />
              <div className="line"></div>
              <MuiTooltip
                title="Change theme"
                placement="right"
                componentsProps={{
                  tooltip: {
                    sx: {
                      bgcolor: "var(--A_background73)",
                      color: "var(--A_font-color48)",
                      padding: "0.3rem 0.8rem",
                    },
                  },
                }}
              >
                <div className="change-theme">
                  <ToggleTheme />
                </div>
              </MuiTooltip>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};
export default SidebarApp;
